import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authenticateWithSsoCode } from '../../shared/services/auth/AuthService';
import { useAuth } from '../../shared/contexts/auth/AuthContext';
import { PROJECTS } from '../../shared/routes/path';

// Reverse SSO landing (masterclass → ChatBeat). Reads the one-time `?code=`, exchanges it for a real
// session, and drops the user into the app — same shape as the magic-link login page.
const SsoPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('Invalid sign-in link.');
      return;
    }

    const authenticate = async () => {
      try {
        const tokenData = await authenticateWithSsoCode(code);
        login(tokenData);
        navigate(PROJECTS);
      } catch {
        setError('This sign-in link is invalid or has expired. Please try again from masterclass.');
      }
    };

    authenticate();
  }, [searchParams]);

  if (error) {
    return (
      <div className="auth-pages">
        <div className="auth-pages__right">
          <div className="form-box">
            <div className="form-box__title">Login failed</div>
            <p>{error}</p>
            <a href="/login">Back to login</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-pages">
      <div className="auth-pages__right">
        <div className="form-box">
          <div className="form-box__title">Logging you in...</div>
          <p>Please wait while we sign you in.</p>
        </div>
      </div>
    </div>
  );
};

export default SsoPage;
